import {
    FETCH_ORDER_DETAILS_ERROR,
    FETCH_ORDER_DETAILS_REQUEST,
    FETCH_ORDER_DETAILS_SUCCESS,
} from '../constants/ActionTypes'
import { timeout, delay } from '@ynap/promise-utils'
import { OrderHistory, ResponseError } from '@ynap/api-utils'
import { push } from 'connected-react-router'

function fetchOrderDetailsRequest() {
    return {
        type: FETCH_ORDER_DETAILS_REQUEST,
    }
}

function fetchOrderDetailsSuccess(order) {
    return {
        type: FETCH_ORDER_DETAILS_SUCCESS,
        order,
    }
}

function fetchOrderDetailsError() {
    return {
        type: FETCH_ORDER_DETAILS_ERROR,
    }
}

export default function fetchOrderDetails(externalOrderId, guestUser, email) {
    return (dispatch, getState, fetch) => {
        const { config, locale, router = {}, uberToken } = getState()
        const { country, langId } = locale
        const { location = {} } = router
        const { pathname } = location
        const { clientRequest } = config.head || config
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce
        const { brandId } = config.watsonService || config.global.application

        if (!guestUser && !uberToken) {
            /**
             * The below `Promise.resolve().then...` is a mitigation for the unintended behaviour
             * described on this thread: https://github.com/ReactTraining/react-router/issues/5655
             *
             * When server-side rendering, a bug in `react-router-redux` causes immediate changes
             * to `history` on the client to be missed. The `Promise.resolve().then...` ensures our
             * push happens on the next available "tick", thereby avoiding this behaviour.
             */
            return Promise.resolve().then(() => dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`)))
        }

        dispatch(fetchOrderDetailsRequest())

        const request = OrderHistory.getOrderDetails({
            baseUrl,
            brandId,
            country,
            externalOrderId,
            uberToken: email ? undefined : uberToken, // Guest order should not send uberToken when email exists. See:TONWEB-2775
            clientId,
            clientSecret,
            email,
            langId,
        })

        //todo look at if this is shareable across state packages
        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((res) => {
                const { ok, status } = res

                if (ok) {
                    return res.json().then((json) => dispatch(fetchOrderDetailsSuccess(json)))
                } else if (status === 400 && guestUser) {
                    return dispatch(fetchOrderDetailsError())
                } else if (status === 400 && !guestUser) {
                    return dispatch(push(`/${locale.id}/account/orders`))
                } else if (status === 401 || status === 403) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`))
                }

                throw new ResponseError(res)
            })
            .catch((error) => {
                dispatch(fetchOrderDetailsError())
            })
    }
}
